import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/services/http/http.service';
import { HttpClient } from '@angular/common/http';
import { reimbursementUrl, reimbursementDetailUrl, reimbursementApproverUrl, itineraryDeleteUrl, itineraryDeleteRBUrl } from '../../shared/common/api';

@Injectable()
export class TravelReimbursementService extends HttpService {

  constructor(http: HttpClient) { 
    super('',http);
  }
 
  getFilter() {
    return this.get().map(res => {
      return res['data'];
    }); 
  }

  storeLiquidation(data){
    return this.http.post(reimbursementUrl, data).map((dataResponse) => {
      return dataResponse;
    });
   }

   updateLiquidation(id,data) {
    return this.http.put(reimbursementUrl + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
   }
  
   updateStatus(id,data) {
    return this.http.put(reimbursementUrl + '/status/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
   }

   storeDetail(data){
    return this.http.post(reimbursementDetailUrl, data).map((dataResponse) => {
      return dataResponse;
    });
   }

   updateDetail(id,data) {
    return this.http.put(reimbursementDetailUrl + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
   }

   approverUpdateStatus(id,data) {
    return this.http.put(reimbursementApproverUrl + '/status/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

  deleteliquidation(data) {
    return this.http.put(itineraryDeleteRBUrl, data).map((dataResponse) => {
      return dataResponse;
    })
  }  
}
